import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { Search_icon, tootltip, view_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";

import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";
import { checkPermission } from "../redux/api/PermissionManager";
import moment from "moment";
import HttpClient from "../../Services/HttpClient";

const BookingView = ({ user_id, property_id, sub_tabs }) => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const { pathname, state } = useLocation();
  const path = pathname?.replace("/", "");
  const navigate = useNavigate();
  const [popup, setPopup] = useState(false);
  const [openReason, setOpenReason] = useState(false);
  const [popupType, setPopupType] = useState(false);
  const [popupValue, setPopupValue] = useState("");
  const location = useLocation();
  const prop_id = location?.state?.property_id;

  console.log("property_id", property_id);
  // console.log("prop_id", prop_id);
  const [page, setPage] = useState(
    // paginationData?.[path]?.page ??
    1,
  );
  const optionsList = {
    currentStatus: [
      { value: 1, label: "Upcoming" },
      { value: 2, label: "Check In" },
      { value: 3, label: "Check Out" },
    ],
    status: [
      { value: 1, label: "Booked", id: 1 },
      { value: 2, label: "Cancelled", id: 4 },
      { value: 3, label: "Hold", id: 9 },
      { value: 4, label: "Release", id: 10 },
      { value: 5, label: "Completed", id: 3 },
    ],
    Upcoming: [
      { value: 1, label: "Booked" },
      { value: 2, label: "Cancelled" },
    ],
    Check_In: [
      { value: 1, label: "Booked" },
      { value: 2, label: "Cancelled" },
      { value: 3, label: "Hold" },
      { value: 4, label: "Release" },
    ],
    Check_Out: [
      { value: 1, label: "Hold" },
      { value: 2, label: "Release" },
    ],
  };
  const [propertiesOption, setPropertiesOption] = useState([]);
  const [pagination, setPagination] = useState({});
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    search: paginationData?.[path]?.search ?? "",
    room: paginationData?.[path]?.room ?? "",
    currentStatus: null,
    status: sub_tabs ? { value: 2, label: "Cancelled", id: 4 } : null,
    property_id: null,
  });

  const [propertyDetails, setPropertyDetails] = useState({});
  const [bookingList, setBookingList] = useState([]);
  useEffect(() => {
    setSelectedFilter((prev) => ({
      ...prev,
      from: moment().format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
    }));
  }, []);
  useEffect(() => {
    const { search, room } = selectedFilter;
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        page: page,
        search: search,
        room: room,
      },
    }));
  }, [
    selectedFilter.search,
    selectedFilter.room,
    page,
    selectedFilter.currentStatus,
    selectedFilter.status,
    selectedFilter.property_id,
  ]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    const { from, search, to, currentStatus, room, status } = selectedFilter;
    const payload = new FormData();
    if (user_id) {
      payload.append("user_id", user_id);
    }
    if (!user_id || (user_id && selectedFilter?.property_id)) {
      payload.append(
        "property_id",
        selectedFilter?.property_id
          ? selectedFilter?.property_id?.value
          : (property_id ?? state?.property_id),
      );
    }
    if (search) {
      payload.append("search", search);
    }
    if ((from && to) || (!from && !to)) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (room) {
      payload.append("room_id", room?.value);
    }
    if (currentStatus) {
      payload.append("current_status", currentStatus?.value);
    }
    if (status) {
      payload.append("status", status?.id);
    }
    const res = await post(
      `${URLS.BOOKED_ROOM_VIEW}?page=${pageNumber}`,
      payload,
    );
    console.log("booking view list", res, res?.data);
    if (res?.status === "success") {
      const modifiedList = res?.room_list?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setPropertyDetails({
        ...res?.property,
        count: res?.count,
        room_list: modifiedList,
      });
      setPagination({
        current_page: pageNumber,
        last_page: res?.next ? pageNumber + 1 : pageNumber,
      });
      setBookingList(res?.bookings ?? []);
    }
  };

  const handleChangeFilter = (name, val) => {
    let { from, to } = selectedFilter;
    if ((from && to) || (from && !to)) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const handleStatus = async (data, val) => {
    let urls = {
      "Check In": URLS.CHECK_IN,
      "Check Out": URLS.CHECK_OUT,
      Cancelled: URLS.CANCEL_BOOKING,
      Hold: URLS.HOLD_BOOKING,
      Release: URLS.RELEASE_BOOKING,
    };
    let payload = {
      booking_code: val ?? popup,
    };
    if (data?.label === "Check In" && popupValue !== popup) {
      toast.error("Booking Id Mismatch");
      return;
    }
    if (data?.label !== "Check In" && data?.label !== "Check Out")
      payload.reason = popupValue;
    let url = urls[data?.label];
    console.log("urls fetch", url, data);
    let res = await post(url, payload);
    if (res?.status === "success") {
      toast.success(res?.message);
      setPopupType(false);
      setPopup(false);
      setPopupValue("");
      getList(page);
    }
  };
  useEffect(() => {
    if (user_id) getProperties();
  }, [user_id]);
  const getProperties = async () => {
    let res = await get(URLS.OVERALL_PROPERTIES);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      console.log("modified list", modifiedList);
      setPropertiesOption(modifiedList);
    }
  };

  //excel

  const exportExcel = async () => {
    let payload = {
      property_id: prop_id,
      from_date: Boolean(selectedFilter.from)
        ? selectedFilter.from
        : moment().format("YYYY-MM-DD"),
      to_date: Boolean(selectedFilter.to)
        ? selectedFilter.to
        : moment().format("YYYY-MM-DD"),
    };
    // console.log("payload", payload);
    // return;
    try {
      let res = await HttpClient.post(URLS.DOWNLOAD_EXCEL, payload, {
        responseType: "blob",
      });
      const blob = new Blob([res?.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "property_bookingList.xlsx";
      link.click();

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("excel download failed:", error);
    }
  };

  const isFinalState = (row) => {
    return (
      row?.status === "Check Out" ||
      row?.status === "Auto Checkout" ||
      row?.status === "Admin Approved Absent" ||
      row?.status?.includes("Cancelled")
    );
  };

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="red"> {(page - 1) * 10 + (row.index + 1)}</p>;
        },
      },
      {
        Header: " Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => {
          return (
            <p
              onClick={() => {
                navigate("/booking-list-view", {
                  state: { type: "edit", booking_id: row.original?.booking_id },
                });
              }}
              className="primary pointer"
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "User",
        accessor: "user",
        Cell: ({ value, row }) => {
          return (
            <p
              onClick={() => navigate("/user-owner")}
              className="primary pointer"
            >
              {value}
            </p>
          );
        },
      },
      {
        Header: "Slot Name",
        accessor: "slot_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " From Date",
        accessor: "from_date",
        Cell: ({ value, row }) => {
          return <p className="">{value}</p>;
        },
      },
      {
        Header: " To Date",
        accessor: "to_date",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Rooms Count",
        accessor: "room_count",
        Cell: ({ value, row }) => {
          return <p className="nowrap">{value}</p>;
        },
      },
      {
        Header: "No of Days",
        accessor: "no_of_days",
        Cell: ({ value, row }) => {
          return <p className="nowrap">{value} </p>;
        },
      },
      {
        Header: " Rooms Category",
        accessor: "room_category",
        Cell: ({ value, row }) => {
          return <p> {value}</p>;
        },
      },
      {
        Header: " Property Price",
        accessor: "property_price",
        Cell: ({ value, row }) => {
          return <p> {value}</p>;
        },
      },
      {
        Header: " Paid Amount",
        accessor: "paid_amount",
        Cell: ({ value, row }) => {
          return <p> {value}</p>;
        },
      },
      {
        Header: " Balance Amount",
        accessor: "balance_amount",
        Cell: ({ value, row }) => {
          return <p> {value}</p>;
        },
      },
      {
        Header: " Guest Name",
        accessor: "guest_name",
        Cell: ({ value, row }) => {
          return <p> {value}</p>;
        },
      },
      {
        Header: "Current Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          const r = row.original;

          const disableEdit =
            !checkPermission("CAN-EDIT-BOOKINGS") ||
            // !property_id ||
            isFinalState(r) ||
            (r?.status === "Admin Approved Absent" && !r?.reason);

          return disableEdit ? (
            <button className="active-btn p-2 w-100 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16">
              {value}
            </button>
          ) : (
            <select
              value={value}
              onChange={(e) => {
                const find = optionsList?.currentStatus?.find(
                  (i) => e.target.value == i?.value,
                );

                if (find?.label === "Check Out") {
                  handleStatus(find, r?.booking_code);
                  return;
                }

                setPopupType(find);
                setPopup(r?.booking_code);
              }}
              className="active-btn p-2 w-100 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16"
            >
              {optionsList?.currentStatus?.map((item) => {
                let minVal =
                  value === "Upcoming" ? 1 : value === "Check In" ? 2 : 3;

                if (
                  item?.value < minVal ||
                  (value === "Upcoming" && item?.label === "Check Out")
                )
                  return null;

                return (
                  <option key={item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          );
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          const r = row.original;

          const disableEdit =
            !checkPermission("CAN-EDIT-BOOKINGS") ||
            // !property_id ||
            value === "Check Out" ||
            value === "Auto Checkout" ||
            (value === "Release" && r?.current_status !== "Check In") ||
            (value === "Owner Cancelled" && !r?.reason) ||
            value === "Admin Approved Absent" ||
            value?.includes("Cancelled");

          return (
            <div className="d-flex flex-row ac-js">
              {disableEdit ? (
                <div style={{ width: "150px" }}>
                  <button
                    className={`${
                      value?.includes("Cancelled") ||
                      value === "Admin Approved Absent"
                        ? "deactive-btn"
                        : value?.includes("Hold")
                          ? "hold-btn"
                          : "active-btn"
                    } p-2 w-100 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16`}
                  >
                    <p
                      className="text-wrap text-white"
                      style={{ lineHeight: "15px" }}
                    >
                      {value}
                    </p>
                  </button>
                </div>
              ) : (
                <div style={{ width: "150px" }}>
                  <select
                    value={value}
                    onChange={(e) => {
                      const find = optionsList?.status?.find(
                        (i) => e.target.value == i?.value,
                      );
                      setPopupType(find);
                      setPopup(r?.booking_code);
                    }}
                    className={`${
                      value?.includes("Cancelled")
                        ? "deactive-btn"
                        : value?.includes("Hold")
                          ? "hold-btn"
                          : "active-btn"
                    } p-2 w-100 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-15 fs-xxl-16`}
                  >
                    {optionsList?.[
                      r?.status === "Hold"
                        ? "Check_In"
                        : r?.current_status?.replace(" ", "_")
                    ]?.map((item) => {
                      let minVal = value?.includes("Hold") ? 3 : 1;
                      if (item.value < minVal) return null;

                      return (
                        <option key={item.value} value={item.value}>
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
              )}

              {r?.reason && (
                <img
                  src={tootltip}
                  onClick={() => setOpenReason(r?.reason)}
                  className="tooltip-icon"
                  alt=""
                />
              )}
            </div>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "booking_id",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              <button
                onClick={() => {
                  navigate("/booking-list-view", {
                    state: { type: "edit", booking_id: value },
                  });
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className="mx-2 edit-btn " />
              </button>
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-BOOKINGS") ? [...d, action] : d;
  }, [property_id, page]);

  console.log("bookingList", bookingList);

  return (
    <div>
      {!property_id && !user_id && <Topbar header={"Bookings View"} />}
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 mt-4 ">
        Total:{propertyDetails?.count}
      </h2>
      {!user_id && (
        <div className="d-flex ac-js mt-4 gap-3 w-100">
          <div className="roles-bg mt-0 rounded-4">
            <h2 className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              Property Name:{" "}
              <span className="f4">{propertyDetails?.property_name}</span>
            </h2>
            <h2 className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Property ID:{" "}
              <span className="f4">{propertyDetails?.property_code}</span>
            </h2>
          </div>
          <div className="roles-bg  mt-0 rounded-4">
            <h2 className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
              Owner Name:{" "}
              <span className="f4">{propertyDetails?.owner_name}</span>
            </h2>
            <h2 className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 ">
              Owner ID:{" "}
              <span className="f4">{propertyDetails?.owner_code}</span>
            </h2>
          </div>
          {!property_id && (
            <div className="roles-bg mt-0  rounded-4">
              <h2 className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
                Service Category:{" "}
                <span className="f4">{propertyDetails?.service_category}</span>
              </h2>
            </div>
          )}
          {property_id && (
            <div className="search-input">
              <input
                onChange={(e) => {
                  handleChangeFilter("search", e.target.value);
                }}
                value={selectedFilter.search}
                type="text"
                placeholder="Search"
                style={{ border: "none", width: "150px" }}
              />
              <img src={Search_icon} className="search" />
            </div>
          )}
        </div>
      )}
      <div className="d-flex flex-wrap ac-je mt-3">
        <div className="d-flex ac-js me-4">
          <button
            onClick={() => exportExcel()}
            className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn mb-3"
            style={{ backgroundColor: "#AE55F5" }}
          >
            {" "}
            Export
          </button>
        </div>
        <div className="d-flex ac-js gap-3">
          <DateRange
            fromValue={selectedFilter.from}
            //  fromValue={}
            toValue={selectedFilter.to}
            setFromDate={(date) => {
              handleChangeFilter("from", date);
            }}
            setToDate={(date) => {
              handleChangeFilter("to", date);
            }}
          />

          {user_id && (
            <Select
              className="location-search"
              options={propertiesOption}
              value={selectedFilter.property_id}
              onChange={(e) => {
                handleChangeFilter("property_id", e);
              }}
              isClearable
              placeholder={"Property ID"}
            />
          )}
          {property_id && (
            <Select
              className="location-search"
              options={optionsList?.currentStatus}
              value={selectedFilter.currentStatus}
              onChange={(e) => {
                handleChangeFilter("currentStatus", e);
              }}
              isClearable
              placeholder={"Check In"}
            />
          )}
          {property_id && (
            <Select
              className="location-search"
              options={optionsList?.status}
              value={selectedFilter.status}
              onChange={(e) => {
                handleChangeFilter("status", e);
              }}
              isClearable
              placeholder={"Booked"}
            />
          )}
          {!user_id && (
            <Select
              className="location-search"
              options={propertyDetails?.room_list}
              value={selectedFilter.room}
              onChange={(e) => {
                handleChangeFilter("room", e);
              }}
              isClearable
              placeholder={"Room Category"}
            />
          )}
          {!property_id && (
            <div className="search-input">
              <input
                onChange={(e) => {
                  handleChangeFilter("search", e.target.value);
                }}
                value={selectedFilter.search}
                type="text"
                placeholder="Search"
                style={{ border: "none", width: "150px" }}
              />
              <img src={Search_icon} className="search" />
            </div>
          )}
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={bookingList}
        show={true}
      />

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je mb-4 ">
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setPopupType(false);
                  setPopup(false);
                  setPopupValue("");
                }}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-80">
                <p
                  className={`f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 ${
                    popupType?.label !== "Check In" && "text-start"
                  } `}
                >
                  {popupType?.label === "Check In"
                    ? " Enter the booking ID"
                    : `Reason For ${popupType?.label}`}
                </p>
                {popupType?.label === "Check In" ? (
                  <input
                    className="input-box mt-1 w-100"
                    onChange={(e) => setPopupValue(e.target.value)}
                    value={popupValue}
                    placeholder="Booking ID"
                  />
                ) : (
                  <textarea
                    className="input-box mt-1 w-100"
                    onChange={(e) => setPopupValue(e.target.value)}
                    value={popupValue}
                    placeholder="Describe..."
                  />
                )}
              </div>
            </div>
            <div className="d-flex ac-jc  mt-5">
              <button
                onClick={() => {
                  if (!popupValue) {
                    toast.error(
                      `Please Enter the Reason For ${popupType?.label}`,
                    );
                    return;
                  }
                  handleStatus(popupType);
                }}
                className="submit-btn"
              >
                submit
              </button>
            </div>
          </div>
        </div>
      )}

      {openReason && (
        <div className="img-popup-design">
          <div className="img-popup">
            <div className="d-flex ac-je mb-4 ">
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setOpenReason(false);
                }}
              />
            </div>
            <div className="w-100 mt-3 d-flex flex-wrap ac-jc gap-4">
              <div className="w-80">
                <p
                  className={`f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20`}
                >
                  {" "}
                  Reason
                </p>
                <textarea
                  className="input-box mt-1 w-100"
                  value={openReason}
                  disabled={true}
                  placeholder="Describe..."
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingView;
